import { render, staticRenderFns } from "./AzVideoCall.vue?vue&type=template&id=9f124b18&scoped=true&"
import script from "./AzVideoCall.vue?vue&type=script&lang=js&"
export * from "./AzVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./AzVideoCall.vue?vue&type=style&index=0&id=9f124b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f124b18",
  null
  
)

export default component.exports